<template>
<div class="manageusers" v-if="profile.admin">
    <h1 class="subheading grey--text">Administrerer brugere</h1>
    <v-container class="mt-1">
        <v-layout row wrap justify-center justify-space-around>
            <v-flex xs12 mt-4>
                <div class="grey--text">Brugere</div>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout column>
            <v-text-field solo label="Søg" append-icon="search" v-model="searchString"></v-text-field>
            <v-data-table :headers="headers" :items="users" class="elevation-1" :pagination.sync="pagination" rows-per-page-text="Rækker per side">
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-left">{{props.item.created}}</td>
                    <td class="text-xs-left">
                        <v-switch name="admin" label="" @change="approveUser(props.item)" v-model="props.item.admin"></v-switch>
                    </td>
                    <td class="text-xs-left">
                        <v-switch name="approved" label="" @change="approveUser(props.item)" v-model="props.item.approved"></v-switch>
                    </td>
                    <td class="text-xs-left">
                        <v-switch name="active" label="" @change="approveUser(props.item)" v-model="props.item.active" color="red darken-3" v-if="!props.item.active"></v-switch>
                        <v-switch name="approved" label="" @change="approveUser(props.item)" v-model="props.item.active" v-if="props.item.active"></v-switch>
                    </td>

                </template>
            </v-data-table>

            <v-switch name="approved" label="Vis inaktiverede brugere" v-model="showInactive"></v-switch>

        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    data() {
        return {
            showInactive: false,
            searchString: '',
            pagination: {
                rowsPerPage: 10
            },
            headers: [{
                    text: 'Navn',
                    align: 'left',
                    value: 'name'
                },
                {
                    text: 'Oprettet',
                    align: 'left',
                    value: 'created'
                },
                {
                    text: 'Administrator',
                    align: 'left',
                    value: 'admin'
                },
                {
                    text: 'Godkendt',
                    align: 'left',
                    value: 'approve'
                },
                {
                    text: 'Aktiv',
                    align: 'left',
                    value: 'active'
                },

            ],
        }
    },
    computed: {
        profile() {
            return this.$store.getters.profile
        },
        users() {
            var result = null;

            result = this.$store.getters.users
            //Filter out inactive users
            if (!this.showInactive) {
                result = result.filter(user => {
                    return user.active !== false || typeof user.active === 'undefined'
                })
            }
            //Filter based on search
            if (this.searchString !== '') {
                result = result.filter(user => {
                    return user.name.toLowerCase().includes(this.searchString.toLowerCase())
                })
            }

            return result

        },
        userid() {
            return this.$store.state.authUser.uid
        }
    },
    created: function () {

    },
    methods: {
        inactivateUser(user) {
            this.$store.dispatch('inactivateUser', {
                user: user,
                vm: this
            })
        },
        approveUser(user) {
            //console.log('approveUser called with' + user)
            this.$store.dispatch('approveUser', {
                user: user,
                vm: this
            })
        },
        // unpproveUser(userid){
        //   this.$store.dispatch('approveUser', {userid: userid, vm: this })
        // },      
        // approvedUserText(approved){
        //   //console.log('approved# ' + approved + '#')
        //   if (approved){

        //       return 'X'
        //   } 
        //   else
        //       return '-'
        // }
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
